import React, { useState, useEffect } from 'react';
import BulletinTable from './BulletinTable';
import { getCommission_bulletinById, clearCardCommission_bulletin } from '../../flux/actions/commissionbulletinActions';
import { Container, Row, Col, Button } from 'reactstrap';

import { connect } from 'react-redux';
import { IBulletinContainer, IBulletinContainerReduxProps } from '../../types/interfaces';

import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faCalendar, faCalendarCheck, faClock, faCommentAlt, faHardHat, faHashtag, faHospitalUser, faMapMarkerAlt, faPen, faPeopleCarry, faSignature, faThermometerHalf, faTruck, faUser, faUserEdit, faUserTie } from '@fortawesome/free-solid-svg-icons'
import { E_ERROR } from '../../types/errors';
import moment from "moment";
import LoadingPage from '../../pages/loading';
import PDFLink from '../pdf/PDFLink';
import { useHistory } from 'react-router-dom';
import { PRIVILEGE } from '../../types/privileges';

const BulletinContainerComponent = ({ 
  getCommission_bulletinById,
  clearCardCommission_bulletin,
  commission_bulletin,
  auth
 }: IBulletinContainer) => {
  const { info, loading } = commission_bulletin;
  const commission = info?.commission_bulletin_lines?.reduce((e, t) => e + (t.commission || 0), 0) || 0;
  const bonusMalusLines = info?.commission_bulletin_lines?.reduce((e, t) => e + (t.bonus_malus || 0), 0) || 0;
  const bonusMalusGlobal = info?.bonus_malus || 0;
  const finalCommission = commission + bonusMalusLines + bonusMalusGlobal;
  
  const history = useHistory();

  let { id } = useParams();

  useEffect(() => {
    if(id !== undefined && id !== null && !isNaN(id) && id >= 0)
      getCommission_bulletinById(id);
    return () => clearCardCommission_bulletin()
  }, []);

  return loading ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col sm="12" md="12"><h2 className="title">Bulletin commission</h2></Col>
        </Row>
      </Container>
      {info ? (
      <Container className="CardInfo">
        <Row>
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>ID Bulletin : </strong>{info.id}
          </Col>
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faUser} />&nbsp;<strong>Commercial : </strong>{info.bulletinComUser ? info.bulletinComUser["LOGIN"] : "-"}
          </Col>
        </Row>
        <Row className="justify-content-start createdAtByRow">
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faUserEdit} />&nbsp;<strong>Saisie par : </strong>{info.bulletinUser ? <div style={{display: "inline-block"}}>{info.bulletinUser["LOGIN"] || ""}</div> : "-"}
            {/* <FontAwesomeIcon icon={faUserEdit} />&nbsp;<strong>Saisie par : </strong>{info.bulletinUser ? <div style={{display: "inline-block"}}>{info.userBS?.surname || ""}{info.userBS?.given_name ? ` ${info.userBS.given_name}` : ""}</div> : "-"} */}
          </Col>
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faClock} />&nbsp;<strong>Saisie le : </strong>{info.createdAt ? moment(info.createdAt).format('DD/MM/YYYY - HH:mm') : "-"}
          </Col>
          {/* {info.updatedAt && info.createdAt !== info.updatedAt ? (
          <Col xs="12" sm="6">
            <FontAwesomeIcon icon={faPen} />&nbsp;<strong>Modifié le : </strong>{info.updatedAt ? moment(info.updatedAt).format('DD/MM/YYYY - HH:mm') : "-"}
          </Col>
          ) : null} */}
        </Row>
        {info.comment ? (
        <Row>
          <Col xs="12">
            <FontAwesomeIcon icon={faCommentAlt} />&nbsp;<strong>Commentaire : </strong>{info.comment}
          </Col>
        </Row>
        ) : null}
        <Row>
          <Col xs="6" className="text-right">
            <strong>Commission brute : </strong>
          </Col>
          <Col xs="6" style={{color: commission > 0 ? "darkgreen" : "darkred"}}>
            {commission.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH"}
          </Col>
        </Row>
        <Row>
          <Col xs="6" className="text-right">
            <strong>Bonus/Malus : </strong>
          </Col>
          <Col xs="6" style={{color: bonusMalusLines > 0 ? "darkgreen" : "darkred"}}>
            {bonusMalusLines > 0 ? "+" : ""}{bonusMalusLines.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH"}
          </Col>
        </Row>
        <Row>
          <Col xs="6" className="text-right">
            <strong>Bonus/Malus global : </strong>
          </Col>
          <Col xs="6" style={{color: bonusMalusGlobal > 0 ? "darkgreen" : "darkred"}}>
            {bonusMalusGlobal > 0 ? "+" : ""}{bonusMalusGlobal.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH"}
          </Col>
        </Row>
        <Row style={{fontSize: "large"}}>
          <Col xs="6" className="text-right">
            <strong>Commission finale : </strong>
          </Col>
          <Col xs="6" style={{color: finalCommission > 0 ? "darkgreen" : "darkred"}}>
            <strong>{finalCommission.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH"}</strong>
          </Col>
        </Row>
        <Row>
          <Col xs="6" className="text-right">
            <strong>Payé : </strong>
          </Col>
          <Col xs="6" style={{color: "darkgreen"}}>
            {Number(Number(info.paid || 0).toFixed(2)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH"}
          </Col>
        </Row>
        <Row>
          <Col xs="6" className="text-right">
            <strong>Reliquat : </strong>
          </Col>
          <Col xs="6" style={{color: "darkorange"}}>
            {Number(((Number((info.commission_bulletin_lines || []).reduce((n, t) => n + Number(t.commission || 0) + Number(t.bonus_malus || 0), 0).toFixed(2)) + Number(info.bonus_malus || 0)) - Number(info.paid || 0)).toFixed(2)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " DH"}
          </Col>
        </Row>
        {info.commission_bulletin_lines ? (
          <Row className="justify-content-center">
            <PDFLink documentType={"commission"}
              data={info}
              download={false}
              style={{marginRight: "10px"}} />
            <PDFLink documentType={"commission"}
              data={info}
              download={false}
              print={true}
              spinner={true}
              style={{marginRight: "10px"}} />
            <PDFLink documentType={"commission"}
              data={info}
              spinner={true} />
          </Row>
        ) : null}
      </Container>
      ) : `ID ${id} non valide.`}
      {info && info.commission_bulletin_lines && auth && auth.user ? <BulletinTable linesData={info.commission_bulletin_lines} /> : null}
    </>
  );
};

const mapStateToProps = (state: IBulletinContainerReduxProps) => ({
  commission_bulletin: state.commission_bulletin,
  auth: state.auth
});

export default connect(mapStateToProps, { getCommission_bulletinById, clearCardCommission_bulletin })(BulletinContainerComponent);
